import { render, staticRenderFns } from "./xingxingLog.vue?vue&type=template&id=8305b722&"
import script from "./xingxingLog.vue?vue&type=script&lang=js&"
export * from "./xingxingLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8305b722')) {
      api.createRecord('8305b722', component.options)
    } else {
      api.reload('8305b722', component.options)
    }
    module.hot.accept("./xingxingLog.vue?vue&type=template&id=8305b722&", function () {
      api.rerender('8305b722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/xingxingLog.vue"
export default component.exports